"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClonedChatMessageThread = isClonedChatMessageThread;
exports.isClonedChatMessage = isClonedChatMessage;
exports.makeChatMessage = makeChatMessage;
exports.makeActionGenerationMessage = makeActionGenerationMessage;
exports.hasContentSummaryInMetadata = hasContentSummaryInMetadata;
exports.getContentSummary = getContentSummary;
const constants_1 = require("@buildwithflux/constants");
const shared_1 = require("@buildwithflux/shared");
const constants_2 = require("./constants");
function isClonedChatMessageThread(thread) {
    return thread.clonedFrom !== undefined;
}
function isClonedChatMessage(message) {
    return message.clonedFrom !== undefined;
}
function makeChatMessage(message) {
    const now = Date.now();
    return {
        uid: message.uid ?? (0, shared_1.guid)(),
        reply_to_message_uid: message.reply_to_message_uid ?? "root",
        created_at: message.created_at ?? now,
        updated_at: message.updated_at ?? now,
        content: message.content ?? "",
        ...message,
    };
}
function makeActionGenerationMessage(message) {
    const metaData = {
        type: "action_generation",
        status: "generating",
        contentSummary: constants_2.actionMessageApplyingSummaries.generic,
    };
    return makeChatMessage({
        ...message,
        owner_uid: constants_1.copilotUid,
        owner_handle: constants_1.copilotHandle,
        meta_data: metaData,
    });
}
function hasContentSummaryInMetadata(metadata) {
    return (metadata?.type === "action_generation" ||
        metadata?.type === "executionIntent" ||
        metadata?.type === "execution_step");
}
function getContentSummary(chatMessage) {
    if (hasContentSummaryInMetadata(chatMessage.meta_data)) {
        return chatMessage.meta_data.contentSummary;
    }
    return chatMessage.contentSummary;
}
//# sourceMappingURL=functions.js.map